import { createTheme } from '@material-ui/core/styles';

export const primary = {
	50: '#e3e4e6',
	100: '#b9bcc0',
	200: '#8a8f96',
	300: '#5b626c',
	400: '#37414d',
	500: '#141f2d',
	600: '#121b28',
	700: '#0e1722',
	800: '#0b121c',
	900: '#060a11',
	A100: '#5389ff',
	A200: '#2066ff',
	A400: '#004aec',
	A700: '#0042d3',
	contrastDefaultColor: 'light',
};
// A custom theme for this app
const theme = createTheme({
	props: {
		// Name of the component ⚛️
		MuiButtonBase: {
			// The properties to apply
			disableRipple: true, // No more ripple, on the whole application 💣!
		},
	},
	// typography: {
	//   fontFamily: ['', 'sans-serif'].join(',')
	// }
	palette: {
		primary,
		//   secondary: {
		//     main: '#19857b'
		//   },
		//   error: {
		//     main: red.A400
		//   },
		//   background: {
		//     default: '#fff'
		//   }
	},
	overrides: {
		MuiOutlinedInput: {
			input: {
				padding: '8px 16px',
			},
		},
		MuiTypography: {
			root: {
				'&.bold-text': {
					fontWeight: '600',
				},
			},
		},
	},
});

export default theme;
